var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center py-5"},[(_vm.miniVariant)?_c('img',{attrs:{"src":require('@/assets/min-logo.jpg'),"alt":"logo","width":"36"}}):_c('img',{attrs:{"src":require('@/assets/logo.jpg'),"alt":"logo","width":"156"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }